export const customizeStatusBar = "_VzLDe";
export const itemsInView = "SnQawd";
export const unreadItemsInView = "HhCeyd";
export const remindersMenuLabel = "ojrxte";
export const zoomSliderMenuLabel = "XOJRve";
export const itemsLabel = "QFnkfe";
export const itemsTooltip = "jNqFW";
export const unreadLabel = "F5R0eb";
export const unreadTooltip = "ykGOcd";
export const statusBarZoom = "stGMcb";
export const statusBarZoomIn = "xJEFYb";
export const statusBarZoomOut = "eHCAg";
export const statusBarZoomLevel = "_kgB1";
export default {customizeStatusBar,itemsInView,unreadItemsInView,remindersMenuLabel,zoomSliderMenuLabel,itemsLabel,itemsTooltip,unreadLabel,unreadTooltip,statusBarZoom,statusBarZoomIn,statusBarZoomOut,statusBarZoomLevel};